import React, {useEffect, useContext,useCallback} from 'react';
import styles from '../../setAlert/info/info.module.css';
import {sensorFailedItem} from '../../../App';
import CommonMenu from '../../menu/commonMenu';
import {useMenu} from '../../../hooks/useMenu';
import useKeyPress from '../../../hooks/useKeyPress';
import Acknowledge from '../../setAlert/acknowledge';
import SubMenuView from '../../views/subMenuView';
import MenuContext from '../../../context/menuContext';
import CommandsContext from '../../../context/commandsContext';
import Home from '../../home';
import { displaySetList } from '../../../App';
import FullBodyMenuView from '../../views/fullBodyMenuView';

function DisplaySetListMenu({onExit}) {
  const {topText, top, infoContent} = styles;
  const {
    onComponent,
    info,
    alert,
    setInfo,
  } = useContext(MenuContext);
  const onLeft = useCallback(() => {
    //onComponent(<RunVerification />);
    //onComponent(null);
    onExit();
  }, []);

  const leftPress = useKeyPress('ArrowLeft');
  const {onUpdateCommands} = useContext(CommandsContext);

 /* useEffect(() => {
    onUpdateCommands({onLeft: onExit});
  }, [onExit, onLeft]);*/

  useEffect(() => {
    if (!leftPress)return;
    
    onLeft();
  }, [leftPress]);

  useEffect(() => {
    onUpdateCommands(commands => ({...commands}));
  }, []);

  // useEffect(() => {
  //   if (!leftPress) return;
  //   onComponent(<Acknowledge />);
  // }, [leftPress]);

  /*useEffect(() => {
    if (alert === false) {
      //onExit();
    }
  }, [alert]);*/

  return (
    <FullBodyMenuView
      title="Display Settings"
      menuItems={displaySetList}
     // onExit={() => onComponent(<Home />)}
      onLeftCallback={onLeft}
    />
  );
}

export default DisplaySetListMenu;
